module.exports = __webpack_public_path__ + "static/img/16areaA_1.9625b1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/16areaA_1.png
// module id = 807
// module chunks = 1